import { module } from './store'
import { addressModule } from './store/address'
import { createModule } from '@vue-storefront/core/lib/module'
import { beforeEach } from './router/beforeEach'
import { beforeRegistration } from './hooks/beforeRegistration'
import { afterRegistration } from './hooks/afterRegistration'

export const KEY = 'user'

export const ADDRESS_KEY = 'address'
export const User = createModule({
  key: KEY,
  store: {
    modules: [
      { key: KEY, module },
      { key: ADDRESS_KEY, module: addressModule}
    ]
  },
  beforeRegistration,
  afterRegistration,
  router: { beforeEach }
})
